//#region ../../packages/constants/date.ts
const datePickTypes = [
	"year",
	"years",
	"month",
	"months",
	"date",
	"dates",
	"week",
	"datetime",
	"datetimerange",
	"daterange",
	"monthrange",
	"yearrange"
];
const WEEK_DAYS = [
	"sun",
	"mon",
	"tue",
	"wed",
	"thu",
	"fri",
	"sat"
];

//#endregion
export { WEEK_DAYS, datePickTypes };
//# sourceMappingURL=date.mjs.map